<template>
  <table id="tblInvoices" class="table table-hover table-center mb-0 datatable"
         v-bind:class="windowWidth < 768 ? 'cards' : ''">
    <thead style="background-color: ghostwhite">
    <tr class="text-center">
      <th scope="col" class="text-left">Number</th>
      <th scope="col" class="text-left">Type</th>
      <th scope="col" class="text-left">{{ $t('sidebar.customer') }}</th>
      <th scope="col" class="text-left">Invoice Date</th>
      <th scope="col" class="text-left">Total</th>
      <th hidden scope="col" class="text-left">Balance</th>
      <th v-if="$i18n.locale !== 'levies'" scope="col" class="text-left">
        Status
      </th>
      <th class="text-right"></th>
    </tr>
    </thead>
    <tbody v-if="invoices.length">
    <tr class="text-center clickable-row" v-for="invoice in invoices" :key="invoice.id" style="margin-bottom: 20px !important; cursor: pointer;" @click="viewInvoice(invoice)">
      <td col="Number: " class="text-left">{{ invoice.invoiceNumber || '-' }}</td>
      <td col="Type: " class="text-left">
        <span v-if="invoice.type === 'INVOICE'" class="badge badge-primary">Invoice</span>
        <span v-else-if="invoice.type === 'CREDIT_NOTE'" class="badge badge-warning">Credit Note</span>
        <span v-else-if="invoice.type === 'DEBIT_NOTE'" class="badge badge-success">Debit Note</span>
        <span v-else class="badge badge-secondary">{{ invoice.type || '-' }}</span>
      </td>
      <td col="Customer: " class="text-left">
        {{ invoice.customer && invoice.customer.name || invoice.customer && invoice.customer.customerId || 'Walk-in' }}
      </td>
      <td col="Invoice Date: " class="text-left">{{ invoice.date ? utcDateToLocal(invoice.date) : '-' }}</td>
      <td col="Total: " class="text-left" :class="invoice.type === 'CREDIT_NOTE' ? 'text-danger' : ''">
        {{ formatDisplayAmount(invoice.currency, invoice.total / 100) }}
      </td>
      <td hidden col="Balance: " class="text-left">
        {{ formatDisplayAmount(invoice.currency, (invoice.balance / 100)) }}
      </td>
      <td v-if="$i18n.locale !== 'levies'" col="Status: " class="text-left">
        <label v-if="invoice.invoiceStatus === 'DRAFT'" class="badge badge-secondary">DRAFT</label>
        <label v-else-if="invoice.invoiceStatus === 'PARTIALLY_PAID'" class="badge text-white"
               style="background-color: darkorange">PARTIAL</label>
        <label v-else-if="invoice.invoiceStatus === 'PAID'" class="badge badge-success" style="color: white">
          <i style="display: none" class="fa fa-check-circle"></i> PAID
        </label>
        <label v-else-if="invoice.invoiceStatus === 'CANCELLED'" class="badge badge-warning" style="color: white">
          <i style="display: none" class="fa fa-times-circle"></i> CANCELLED
        </label>
        <label v-else-if="invoice.invoiceStatus === 'UNPAID'" class="badge badge-danger"
               style="color: white">UNPAID</label>
        <label v-else-if="invoice.invoiceStatus === 'OVERPAID'" class="badge badge-purple"
               style="color: white">OVERPAID</label>
        <label v-else class="badge badge-info">{{ invoice.invoiceStatus }}</label>
      </td>
      <td class="text-right">
        <i class="fas fa-chevron-right text-muted"></i>
      </td>
    </tr>
    </tbody>
  </table>

</template>

<script>
import {utcDateToLocal} from "../../utils/utils";
import invoiceService from "../../service/invoice.service"
import {getConfig} from "../../utils/config"
import {formatDisplayAmount} from "../../utils/money";
import {handleError, showSuccess, showWarning} from "../../utils/notification.utils";

export default {
  name: 'invoice-list-table',
  data() {
    return {
      invoiceId: null,
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false,
      displayDisabledButtons: !getConfig().hideIfNoPermission
    }
  },
  props: {
    invoices: Array,
  },
  methods: {
    utcDateToLocal: utcDateToLocal,
    formatDisplayAmount: formatDisplayAmount,
    viewInvoice(invoice) {
      if (invoice.type === 'CREDIT_NOTE') {
        this.$router.push(`/credit-notes/${invoice.id}`)
      } else if (invoice.type === 'DEBIT_NOTE') {
        this.$router.push(`/debit-notes/${invoice.id}`)
      } else {
        this.$router.push(`/invoices/${invoice.id}`)
      }
    },
    deleteInvoice(id) {
      this.invoiceId = id
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          let loader = this.$loading.show({
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            onCancel: this.onCancel,
          });
          invoiceService.delete(id)
            .then(response => {
              if (response.data.success === true) {
                this.invoices = this.invoices.filter(function (item) {
                  return item.id !== id;
                });
                this.$router.push('/invoices');
                this.retrieveInvoices()
                showSuccess('Successfully deleted invoice')
              } else {
                showWarning('response.data.narrative')
              }
            })
            .catch(e => {
              handleError(e);
            })
            .finally(() => {
              loader.hide()
            })
        }
      })
    },
  },
  computed: {
    windowWidth() {
      return this.$store.state.app.windowWidth;
    },
    buttonTooltip() {
      return this.isDisabled ? 'You do not have access to this feature' : ''
    },
    basedOnWindowWidth() {
      return this.windowWidth > 768;
    }
  },
  watch: {
    windowWidth: function () {
      if (this.windowWidth < 768) {
        this.isMobileView = true
      }
      if (this.windowWidth >= 768 && this.windowWidth <= 1200) {
        this.isTabletView = true
      }
      if (this.windowWidth > 1200) {
        this.isDesktopView = true
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed
}

.clickable-row:hover {
  background-color: #f8f9fa;
}

.cards thead {
  display: none;
}

.cards tr {
  display: flex;
  flex-direction: column;

  margin-bottom: 5px !important;
  /*border: 1px solid navajowhite !important;*/
  border: 1px solid rgba(0, 0, 0, 0.1) !important;;
}

.cards tr > th {
  display: none;
}

.hide-on-mobile {
  display: none;
}

.cards tr > td::before {
  content: attr(col) '';
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/invoices/InvoiceListTable.vue